import type { ConversationTimelineEventResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event-response";
import SettingsIcon from "@redotech/redo-icons/settings-02.svg";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { EventTimestamp } from "./event-timestamp";
import * as styles from "./timeline-event.module.css";

export const ConversationReadEvent = memo(function ConversationReadEvent({
  event,
}: {
  event: ConversationTimelineEventResponse;
}) {
  return (
    <Flex align="flex-start" className={styles.card} dir="row" gap="sm">
      <div className={styles.icon}>
        <SettingsIcon />
      </div>
      <Flex className={styles.content} dir="column" gap="xxs">
        <Text fontSize="xs">Marked as read</Text>
        <EventTimestamp event={event} />
      </Flex>
    </Flex>
  );
});
